import { apiAxios } from "../apiConfig";

export const submitSurvey = async (payload) => {
  try {
    const response = await apiAxios.post("/surveys", payload);
    return response.data;
  } catch (error) {
    console.error("Error submitting survey:", error);
    throw error;
  }
};
